export default "__VITE_ASSET__d9014963__"